import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight, PlayCircle, Workflow } from 'lucide-react'
import { suite, steps, readiness } from '../content/aiOpsSuite'
import { stepIcons } from '../content/aiOpsIcons'

export default function AIOpsSuiteBand() {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-void-950 via-synth-950/20 to-void-950" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-synth-900/40 border border-synth-700/40 text-synth-300 text-sm font-medium mb-6">
            <Workflow className="w-4 h-4" />
            {suite.eyebrow}
          </span>
          <h2 className="section-title mb-4">
            Run AI like an <span className="text-gradient">operation</span>
          </h2>
          <p className="section-subtitle mx-auto">
            Shape a request, work through your documents, automate the steps, run them on a
            schedule, and measure what worked — local RAG and DAG operations on hardware you control, under 23Controls™ governance.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {steps.map((s, i) => {
            const Icon = stepIcons[s.id]
            return (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
              >
                <Link
                  to={`/ai-operations/${s.id}`}
                  className="group flex flex-col h-full p-5 rounded-2xl bg-void-900/40 border border-void-800/50 hover:border-synth-700/50 transition-all hover:-translate-y-1"
                >
                  <div className="flex items-center justify-between mb-4">
                    <span className="font-mono text-xs text-void-500">{String(i + 1).padStart(2, '0')} · {s.verb}</span>
                    <span className={`px-2 py-0.5 rounded-full border text-[10px] font-medium ${readiness[s.status].className}`}>
                      {readiness[s.status].label}
                    </span>
                  </div>
                  <div className="p-2.5 rounded-xl bg-gradient-to-br from-synth-500 to-signal-600 w-fit mb-3">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="font-display font-semibold text-void-100 mb-2 group-hover:text-synth-300 transition-colors">
                    {s.name}
                  </h3>
                  <p className="text-void-400 text-sm leading-relaxed flex-1">{s.tagline}</p>
                </Link>
              </motion.div>
            )
          })}
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/ai-operations" className="btn-primary inline-flex items-center gap-2">
            Explore the AI Operations Suite <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/demo" className="btn-secondary inline-flex items-center gap-2">
            <PlayCircle className="w-4 h-4" /> Take the guided demo
          </Link>
        </div>
      </div>
    </section>
  )
}
